import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button, Form, Input, message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import useAuthContext from '../../contexts/AuthContext';

const ForgotPwdForm = ({ switchForm }) => {
  const { t } = useTranslation();
  const { dispatchAPI } = useAuthContext();
  const [isLoading, setLoading] = useState(false);

  const askForPwdReset = async (email) => {
    setLoading(true);
    try {
      await dispatchAPI('GET', { url: `customers/createAccount/${email}` });
      message.success(t('login.customerEmail', { email }));
      switchForm('login');
    } catch (e) {
      if (e?.response?.data?.message && e?.response?.status === 403)
        message.error(e.response.data.message);
      if (e?.response?.status === 401) message.error(e.response.data.message);
      else message.error(t('login.resetPwdEmailError'));
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    await askForPwdReset(values.username.toLowerCase());
  };

  return (
    <Form onFinish={handleSubmit}>
      <Form.Item
        name="username"
        rules={[
          { required: true, message: t('login.usernameMissing') },
          { type: 'email' }
        ]}
      >
        <Input
          prefix={
            <MailOutlined style={{ color: 'var(--textColorSecondary)' }} />
          }
          placeholder={t('login.username')}
        />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ width: '100%' }}
          loading={isLoading}
        >
          {t('login.customerPwd')}
        </Button>
      </Form.Item>
      <Form.Item>
        <Button
          type="link"
          block
          style={{
            color: 'var(--textColorSecondary)',
            width: '100%'
          }}
          onClick={() => switchForm('login')}
        >
          {t('buttons.back')}
        </Button>
      </Form.Item>
    </Form>
  );
};

ForgotPwdForm.propTypes = {
  switchForm: PropTypes.func.isRequired
};

export default ForgotPwdForm;
